import { Modal, ModalBody, ModalHeader } from "reactstrap"

import ConfirmationForm from "@components/common/form/ConfirmationForm"
import TranslatedHtml from "@components/common/TranslatedHtml"


interface IProps {
  title: string
  content: string | JSX.Element
  contentTranslationParams?: Record<string, any>
  modalOpen: boolean
  onSubmit: (...args: any) => void
  submitButtonDisabled?: boolean
  submitButtonLabel?: string
  hint?: { className?: string; content: string }
  toggle: () => void
}

/**
 * A Modal to ask the user to confirm a small update, e.g. a deletion of an object like a workpackage, where
 * no further data input is requiered.
 * Currently, also used for setting a new password.
 */
const ConfirmModal: React.FC<IProps> = (props: IProps) => {
  const { title, content, contentTranslationParams, modalOpen, submitButtonLabel = "form.confirm", submitButtonDisabled = false, hint, onSubmit, toggle } = props

  return <Modal isOpen={modalOpen} toggle={toggle}>
    <ModalHeader>
      {title}
    </ModalHeader>
    <ModalBody>
      {hint && <p className={hint.className ? hint.className : ""}>
        <TranslatedHtml content={hint.content} />
      </p>}
      {typeof content === "string" ? <p><TranslatedHtml content={content} params={contentTranslationParams} /></p> : content}
      <ConfirmationForm
        onSubmit={onSubmit}
        onCancel={toggle}
        submitButtonLabel={submitButtonLabel}
        submitButtonDisabled={submitButtonDisabled} />
    </ModalBody>
  </Modal>
}

export default ConfirmModal
